import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

var linkTheme = createTheme(shippoTheme, {
    palette: {
        alternate: colors.accent.foreground.informational,
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: ({ ownerState }) => {
                    return (() => {
                        const baseStyle = {
                            cursor: 'pointer',
                            ':focus': {
                                outline: `4px solid ${colors.hoverFocus}`,
                                borderRadius: '2px',
                            },
                        };
                        switch (ownerState.color) {
                            case 'primary':
                                return Object.assign(Object.assign({}, baseStyle), { color: colors.primary, textDecorationColor: colors.primary, ':hover': {
                                        color: colors.primaryButtonHover,
                                        textDecorationColor: colors.primaryButtonHover,
                                    }, 'h3, h4, p, span': {
                                        color: colors.primary,
                                        textDecorationColor: colors.primary,
                                        ':hover': {
                                            color: colors.primaryButtonHover,
                                            textDecorationColor: colors.primaryButtonHover,
                                        },
                                    } });
                            case 'secondary':
                                return Object.assign(Object.assign({}, baseStyle), { color: colors.text.default, textDecorationColor: colors.text.default, ':hover': {
                                        color: colors.secondary,
                                        textDecorationColor: colors.secondary,
                                    }, 'h3, h4, p': {
                                        color: colors.text.default,
                                        textDecorationColor: colors.text.default,
                                        ':hover': {
                                            color: colors.secondary,
                                            textDecorationColor: colors.secondary,
                                        },
                                    } });
                            default:
                                return Object.assign(Object.assign({}, baseStyle), { color: colors.text.default, textDecorationColor: colors.text.default, ':hover': {
                                        color: colors.secondary,
                                        textDecorationColor: colors.secondary,
                                    }, 'h3, h4, p': {
                                        color: colors.text.default,
                                        textDecorationColor: colors.text.default,
                                        ':hover': {
                                            color: colors.secondary,
                                            textDecorationColor: colors.secondary,
                                        },
                                    } });
                        }
                    })();
                },
            },
        },
    },
});

export { linkTheme as default };
//# sourceMappingURL=Link.theme.js.map
